export default "__VITE_PUBLIC_ASSET__1ced6ca7__"